import React, { useState, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import Button from '../Button';
import './Intro.scss';

const Intro = () => {
  const container = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const springStyle = useSpring({
    opacity: isIntersecting ? 1 : 0,
    space: isIntersecting ? 0 : 100,
    config: {
      tension: 120,
    },
  });

  const observe = useCallback(entry => {
    if (entry[0].isIntersecting) {
      setIsIntersecting(true);
      return;
    }

    setIsIntersecting(false);
  }, []);

  useIntersectionObserver(observe, container, '-100px');

  return (
    <section className="wtm-intro">
      <div className="container">
        <div className="content">
          <h1 className="title">Women Techmakers Seoul 2019</h1>
          <div className="event">
            <h2 className="event-info"><i className="wtm-icon fas fa-calendar-check"></i> 2019년 04월 13일 토요일 12:00 - 18:00</h2>
            <h2 className="event-info"><i className="wtm-icon fas fa-map-pin"></i> 서울, 코엑스 4F 남쪽 컨퍼런스룸</h2>
          </div>
          <div className="desc">
            <p>
              <b>2019년 4월 13일, Women TechMakers Seoul 2019</b>는 테크 업계 여성들의 목소리에
              집중하려고 합니다. 일하면서 겪었던 어려움과 고민을 나눠주세요. WTM은 더 많은 여성들이
              테크 업계에서 활발히 활동하고, 영향력을 키워나갈 수 있도록 지원하고 있습니다.{' '}
            </p>
            <p>
              Women TechMakers Seoul 2019의 테마는 <b>다시 만난 세계</b>입니다. 우리는 타인을 통해
              나를 발견하기도 하고, 서로의 경험을 공유하면서 성장의 발판으로 삼기도 합니다.
              참가하시는 여러분들의 미래가 더욱 빛날 수 있는 시간들을 마련했습니다.
              <br />
              <b>함께 해주세요!</b>
            </p>
          </div>
        </div>
        <div className="hifive" ref={container}>
          <animated.img
            className="hifive-img hifive-img-left"
            src="/img/webwoman-blue.png"
            alt=""
            style={interpolateStyle(v => `translateX(-${v}px) translateY(${v / 5}px)`)(springStyle)}
          />
          <animated.img
            className="hifive-img hifive-img-right"
            src="/img/webwoman-green.png"
            alt=""
            style={interpolateStyle(v => `translateX(${v}px) translateY(${v / 5}px)`)(springStyle)}
          />
        </div>
        <div className="tt-link">
            <h3>
                시간표에서 발표자료를 확인해보세요!<br/>
                <br/>
                나의 이야기가 우리의 이야기로<br/>
                확장되는 경험을 놓치지 마세요!
            </h3>
            <Link to="/timeTable">
              <Button btnText="벌표자료 알아보기"
                      extraClassName="btn-main-event btn-lg btn-green"
                      absoluteUrl=""/>
            </Link>
        </div>
      </div>
    </section>
  );
};

export default Intro;

function interpolateStyle(transform) {
  return function(style) {
    const interpolated = style.space.interpolate(transform);
    return {
      ...style,
      transform: interpolated,
      WebkitTransform: interpolated,
    };
  };
}
